import React from 'react'; 
import HGStatus from "../../components/HGStatus";  

export const OnlineStatus = ({ device }) => {
    const currentTime = Date.now() / 1000;
    //if device.ts exists then use that or use device.latestStateTs for packs
    let ts = device?.ts || device?.latestStateTs; 
    //format timestamp if it is in milliseconds
    if (ts > 2000000000) {
        ts = ts / 1000;
    }
    const isOnline = ts && ts + 60 * 10 > currentTime ? 'online' : 'offline';  
    return <HGStatus online={isOnline}  />;
};
